import { Accordion, AccordionDetails, AccordionSummary, Toolbar, Typography } from '@mui/material'
import { ButtonEx, FlexBoxProps, FlexCol, FlexGrowRow, FlexRow, useAsyncEffect } from '@xylabs/sdk-react'
import BigNumber from 'bn.js'
import { useState } from 'react'
import { FaAngleDown } from 'react-icons/fa'

import { useGeotoken } from '../../../../Contexts'
import { shiftBase10 } from '../../../../shiftBase10'
import ItemContainer from './ItemContainer'
import ItemSlot from './ItemSlot'
import ItemSlotType from './ItemSlotType'

const Rewards: React.FC<FlexBoxProps> = (props) => {
  const geotoken = useGeotoken()
  const [amount, setAmount] = useState<BigNumber | null>()

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (mounted) => {
      if (geotoken) {
        const amount = await geotoken?.getBalance()
        console.log(`amount: ${amount?.toString()}`)
        if (mounted()) {
          setAmount(amount)
        }
      }
    },
    [geotoken],
  )

  const config: ItemSlot[][] = [
    [{ type: ItemSlotType.Equippable }, { type: ItemSlotType.Disabled }, { type: ItemSlotType.Disabled }, { type: ItemSlotType.Disabled }],
  ]

  const rewards: ItemSlot[][] = [
    [
      { item: { moniker: 'energy-unit', name: 'Energy', quantity: 0 }, type: ItemSlotType.Currency },
      { item: { moniker: 'datanium-unit', name: 'Datanium', quantity: 0 }, type: ItemSlotType.Currency },
      { item: { moniker: 'matter-unit', name: 'Matter', quantity: 0 }, type: ItemSlotType.Currency },
      { item: { moniker: 'coin-unit', name: 'COIN', quantity: 0 }, type: ItemSlotType.Currency },
      {
        item: { moniker: 'xyo-unit', name: 'XYO', quantity: shiftBase10(amount, -18)?.toNumber() ?? 0 },
        type: ItemSlotType.Currency,
      },
    ],
  ]

  return (
    <FlexRow paper {...props} justifyContent="stretch">
      <Accordion style={{ flexGrow: 1 }} defaultExpanded>
        <AccordionSummary>
          <FlexGrowRow justifyContent="space-between">
            <Typography variant="caption">Rewards</Typography>
            <FaAngleDown />
          </FlexGrowRow>
        </AccordionSummary>
        <AccordionDetails>
          <FlexCol flexWrap="wrap" alignItems="stretch">
            <ItemContainer name="Active Tools" slots={config} margin={1} />
            <ItemContainer name="Stored Currency" slots={rewards} margin={1} />
          </FlexCol>
          <Toolbar>
            <ButtonEx></ButtonEx>
          </Toolbar>
        </AccordionDetails>
      </Accordion>
    </FlexRow>
  )
}

export default Rewards
